<template>
  <div class="">
    <ff-button
      v-if="!loading"
      :action="connect"
      :text="text"
      :icon="'payments'"
      :class="classes"/>
    <ff-inline-loading
      v-if="loading"
      :saving="loading"
      :full="true"
    />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { mapState } from 'vuex'
import 'firebase/functions'
import FFButton from '../DesignSystem/FFButton'
import FFInlineLoading from '../DesignSystem/FFInlineLoading'

export default {
  name: 'connect-stripe',
  props: [
    'sidebar',
    'text',
    'url'
  ],
  components: {
    'ff-button': FFButton,
    'ff-inline-loading': FFInlineLoading
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async connect () {
      this.loading = true
      let url = this.url
      if (url) return window.open(`${url}`, '_blank')
      let func = firebase.functions().httpsCallable('stripe-startStripe')
      try {
        let result = await func({returnUrl: window.location.origin + '/settings'})
        this.loading = false
        return window.open(`${result.data.url}`, '_blank')
      }
      catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  },
  computed: {
    ...mapState(['channel_id']),
    classes () {
      if (this.sidebar) {
        return ['sidebar-pages__item', 'is-sidebar']
      }
      return null
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .is-sidebar {
    @include sidebar-item;
  }

</style>
